export const isAuthenticatedSelector = (state) => state.auth.isAuthenticated;
export const accessTokenSelector = (state) => state.auth.accessToken;
export const currentUserId = (state) => state.auth.userId;
export const operatingCountrySelector = (state) => state.auth.operatingCountry;
